import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { IOption } from "ng-select";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs/Subscription";
import { BatchService } from "../batch.service";
import * as XLSX from "xlsx";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { ToastrService } from "ngx-toastr";
import { BsModalService } from "ngx-bootstrap/modal";
import { ConfirmationService } from "primeng/primeng";
import { FormBuilder, FormGroup } from "@angular/forms";
import { PagerService } from "../../../../../common/services/Pagination.service";
import { environment } from "../../../../../../environments/environment";
import { ModalListBatchChildComponent } from "../list/modalListBatchChild.component";
declare function baseTracking(appId);
declare function enterScreenView(screenName: any, contentType: any, referrer: any);
declare function visibleContent(regionName: any, contentName: any, index: any);
declare function clickTracking(regionName: any, contentName: any, target: any, payload: any);
declare function alertMsg(alertType: any, alertMessage: any);
declare function searchEvent(keywords: any, params: any, order: any, sort: any)
declare var $: any;
var that;
@Component({
  selector: "app-import-stamp",
  templateUrl: "./import-stamp.component.html",
  styleUrls: ["./import-stamp.component.css"]
})
export class ImportStampComponent implements OnInit {
  @Output("hideImport") hide = new EventEmitter();
  @Input("batchID") batchID: any = null;
  public FormFilterBatchStamp: FormGroup;
  isSelectBatch: boolean = true;
  model: any = {};
  bsModalRef: BsModalRef;
  bsModalImport: BsModalRef;
  bsModalDownload: BsModalRef;
  isExcel: boolean = true;
  isImporting: Boolean = false;
  fileExcel: any;
  columns: any = {};
  excel: any = {};
  allBatchs: any = [];
  numberSheet: any = null;
  numberStamp: any = null;
  isLoadingFile: any = false;

  subcribe: Subscription = null;

  public qrm: string = "";
  numberID: number = 0;
  listBatchs: Array<IOption> = [];
  isImport: boolean = false;
  listDataImport: any = [];

  //status batch
  batch_not_pay = 0;
  batch_paid = 1;
  batch_activated = 2;
  is_printing = 1;
  list_status_filter: Array<IOption> = [];
  Infinity = Infinity;

  public currentPage: number = 1;
  public current_filter: any = {};
  public pager: any;
  public page_size: number = 10;
  public totalRow: number = 0;

  public list_items: any = [];

  code_chonggia = 1;
  code_baohanh = 2;
  code_tranhang = 3;

  public item_detail: any = {};
  public item_active: number = 0;
  has_list: boolean = true;
  loadingDetail: boolean = false;

  no_product = "assets/images/no_product.png";
  no_image = "assets/images/no-image.png";

  is_downloading_batch: boolean = false;
  subcribeModal: Subscription;
  hasChild: boolean = false;
  listBatchChild: Array<IOption> = [];
  allBatchChild: any = [];
  isBackupBatch: boolean = false;
  isBackupChild: boolean = false;
  loadingChild: boolean = false;
  selectedChild: boolean = false;
  constructor(
    private batchService: BatchService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private confirmationService: ConfirmationService,
    private pagerService: PagerService,
    private translate: TranslateService
  ) {
    that = this;

    this.translate.onLangChange.subscribe(() => {
      this.initStatusFilter();
    });
    this.initStatusFilter();
  }

  initStatusFilter() {
    this.list_status_filter = [
      { value: this.batch_paid.toString(), label: this.translate.instant("CHUA_KICH_HOAT") },
      { value: this.batch_activated.toString(), label: this.translate.instant("DA_KICH_HOAT") }
    ];
  }
  hideImport() {
    this.hide.emit();
  }

  ngOnInit() {
    this.openImport();
  }

  convertServiceToText(service: string) {
    let arr_services: Array<{ code: number; name: string }> = [];
    if (service.indexOf(this.code_chonggia.toString()) != -1) {
      arr_services.push({ code: this.code_chonggia, name: this.translate.instant("CHONG_GIA") });
    }
    if (service.indexOf(this.code_baohanh.toString()) != -1) {
      arr_services.push({ code: this.code_baohanh, name: this.translate.instant("BAO_HANH") });
    }
    if (service.indexOf(this.code_tranhang.toString()) != -1) {
      arr_services.push({ code: this.code_tranhang, name: this.translate.instant("TRAN_HANG") });
    }
    return arr_services;
  }

  selectTab() {
    //let excel = $('#excel')[0].checked;
    if (this.isExcel) {
      this.fileExcel = null;
      this.numberStamp = null;
      this.numberSheet = null;
      this.excel = {};
      $("#fileSelect").val("");
      this.isLoadingFile = false;
      this.hasChild = false;
    } else {
      this.numberID = -1;
      if (this.listDataImport.length > 0)
        for (let i = 0; i < this.listDataImport.length; i++) {
          $("#" + "info" + this.listDataImport[i].toString()).remove();
          that.listDataImport.splice(i, 1);
        }
    }
  }
  openImport() {
    this.isExcel = true;
    this.isImport = false;
    this.fileExcel = null;
    this.numberStamp = null;
    this.numberSheet = null;
    this.excel = {};
    this.numberID = -1;
    this.isImporting = true;
    this.isLoadingFile = false;
    this.hasChild = false;
    let opt: any = {
      limit: 1000
    };
    this.batchService
      .getBatchesList(opt)
      .toPromise()
      .then(res => {
        if (!res.error) {
          let batchs = res.data.batches;
          this.allBatchs = res.data.batches;
          let listBatchs: any = [];
          for (let i = 0; i < batchs.length; i++) {
            let item = {
              value: batchs[i].id.toString(),
              label: batchs[i].name
            };
            listBatchs.push(item);
          }
          this.listBatchs = listBatchs;
          if (this.batchID) {
            this.excel.batch = this.batchID.toString();
            this.selectBatch();
          }
          //this.bsModalImport = this.modalService.show(template, { class: 'modal-lg' });
        }
      });
  }
  selectImport() {
    this.fileExcel = null;
    $("#fileSelect").val("");
    this.numberStamp = null;
    this.numberSheet = null;
    this.isLoadingFile = false;
  }
  changeFileExcel(evt) {
    this.isLoadingFile = true;
    const target: DataTransfer = <DataTransfer>evt.target;
    if (target.files.length !== 1) {
      this.toastr.warning(this.translate.instant("CHI_DUOC_CHON_1_FILE"), "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right"
      });
    }
    var file = target.files["0"];
    if (file) {
      var ValidImageTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel"
      ];
      if (ValidImageTypes.indexOf(file.type) < 0) {
        this.toastr.error(
          this.translate.instant("DINH_DANG_FILE_KHONG_PHU_HOP"),
          "",
          {
            timeOut: 4000,
            positionClass: "toast-bottom-right"
          }
        );
        this.fileExcel = null;
        $("#fileSelect").val("");
        this.numberStamp = null;
        this.numberSheet = null;
        this.isLoadingFile = false;
        return;
      } else {
        this.fileExcel = file;
      }
    }

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });
      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      let listSheetNames: any = [];
      listSheetNames = wb.SheetNames;
      let numberData = 0;
      let isTrueData: boolean = false;
      for (let i = 0; i < listSheetNames.length; i++) {
        const sheetRead: XLSX.WorkSheet = wb.Sheets[listSheetNames[i]];
        let data = <any>XLSX.utils.sheet_to_json(sheetRead, { header: 1 });
        if (data.length > 1) {
          let title = data[0];
          if (title.length < 4) {
            this.toastr.error(
              this.translate.instant("FILE_KHONG_HOP_LE_TAI_LAI"),
              "",
              {
                timeOut: 4000,
                positionClass: "toast-bottom-right"
              }
            );
            this.fileExcel = null;
            $("#fileSelect").val("");
            this.numberStamp = null;
            this.numberSheet = null;
            this.isLoadingFile = false;
            return;
          } else {
            if (title[0] && title[1] && title[2] && title[3]) {
              if (
                title[0].toLowerCase() !== "serial" ||
                title[1].toLowerCase() !== "qrm" ||
                title[2].toLowerCase() !== "qri" ||
                title[3].toLowerCase() !== "sms"
              ) {
                this.toastr.error(
                  this.translate.instant("FILE_KHONG_HOP_LE_TAI_LAI"),
                  "",
                  {
                    timeOut: 4000,
                    positionClass: "toast-bottom-right"
                  }
                );
                this.fileExcel = null;
                $("#fileSelect").val("");
                this.numberStamp = null;
                this.numberSheet = null;
                this.isLoadingFile = false;
                return;
              } else {
                let count = data.length;
                for (let i = 0; i < count; i++) {
                  if (data[i] && data[i].length <= 0) {
                    data.splice(i, 1);
                    i--;
                  }
                }
                if (data.length - 1 > 50000) {
                  this.toastr.error(
                    this.translate.instant("SHEET_TOI_DA_50000_TEM"),
                    "",
                    {
                      timeOut: 4000,
                      positionClass: "toast-bottom-right"
                    }
                  );
                  this.fileExcel = null;
                  $("#fileSelect").val("");
                  this.numberStamp = null;
                  this.numberSheet = null;
                  this.isLoadingFile = false;
                  return;
                } else {
                  numberData += data.length - 1;
                  isTrueData = true;
                }
              }
            } else {
              this.toastr.error(
                this.translate.instant("FILE_KHONG_HOP_LE_TAI_LAI"),
                "",
                {
                  timeOut: 4000,
                  positionClass: "toast-bottom-right"
                }
              );
              this.fileExcel = null;
              $("#fileSelect").val("");
              this.numberStamp = null;
              this.numberSheet = null;
              this.isLoadingFile = false;
              return;
            }
          }
        } else if (data.length <= 0 && isTrueData == false) {
          this.toastr.error(
            this.translate.instant("KHONG_TIM_THAY_DU_LIEU_TRONG_FILE"),
            this.translate.instant("FILE_KHONG_HOP_LE"),
            {
              timeOut: 4000,
              positionClass: "toast-bottom-right"
            }
          );

          this.fileExcel = null;
          $("#fileSelect").val("");
          this.numberStamp = null;
          this.numberSheet = null;
          this.isLoadingFile = false;
          return;
        }
      }
      this.numberSheet = listSheetNames.length;
      this.numberStamp = numberData;
      if (this.numberStamp > this.excel.number) {
        this.toastr.error(
          this.translate.instant("FILE_KHONG_HOP_LE"),
          this.translate.instant("SO_LUONG_TEM_NOI_BO_KHONG_DUOC_LON_HON_TEM_LO"),
          // Note: added a more generic key or I should use manual construction
          {
            timeOut: 5000,
            positionClass: "toast-bottom-right"
          }
        );

        this.fileExcel = null;
        $("#fileSelect").val("");
        this.numberStamp = null;
        this.numberSheet = null;
        this.isLoadingFile = false;
        return;
      }

      this.isLoadingFile = false;
    };
    reader.readAsBinaryString(target.files[0]);
  }
  allowSelectBatch() {
    this.excel = {};
    this.fileExcel = null;
    $("#fileSelect").val("");
    this.numberStamp = null;
    this.numberSheet = null;
    this.isLoadingFile = false;
    this.isBackupBatch = false;
    this.isBackupChild = false;
  }
  selectBatch() {
    if (this.excel.batch) {
      let option: any = {
        limit: 500
      };
      this.loadingChild = true;
      this.batchService
        .getListBatchChild(this.excel.batch, option)
        .subscribe(res => {
          this.loadingChild = false;
          if (!res.error) {
            if (res.data.batches.length > 0) {
              this.hasChild = true;
              let batchs = res.data.batches;
              this.allBatchChild = res.data.batches;
              let listBatchChild: any = [];
              for (let i = 0; i < batchs.length; i++) {
                let item = {
                  value: batchs[i].id.toString(),
                  label: batchs[i].name
                };
                listBatchChild.push(item);
              }
              this.listBatchChild = listBatchChild;
            } else {
              this.hasChild = false;
            }
          }
        });
      let batch = parseInt(this.excel.batch);
      var found = this.allBatchs.find(function (element) {
        if (element["id"] === batch) return element;
      });
      if (found) {
        this.excel.batch_id = this.excel.batch;
        this.excel.id_start = found.id_start;
        this.excel.id_end = found.id_end;
        this.excel.number = found.id_end - found.id_start + 1;
        this.excel.prefix = found.prefix;
        this.excel.numberStart = this.formatNumber(found.id_start);
        this.excel.numberEnd = this.formatNumber(found.id_end);
        if (found.last_imported && found.quantity_imported > 0) {
          this.isBackupBatch = true;
        } else {
          this.isBackupBatch = false;
        }
      }
    } else {
      this.excel = {};
      this.hasChild = false;
      this.isBackupBatch = false;
    }

    this.fileExcel = null;
    this.numberStamp = null;
    this.numberSheet = null;
    $("#fileSelect").val("");
  }
  selectBatchChild() {
    if (this.excel.batchChild) {
      let batch = parseInt(this.excel.batchChild);
      var found = this.allBatchChild.find(function (element) {
        if (element["id"] === batch) return element;
      });
      if (found) {
        this.excel.batch_id = this.excel.batchChild;
        this.excel.id_start = found.id_start;
        this.excel.id_end = found.id_end;
        this.excel.number = found.id_end - found.id_start + 1;
        this.excel.prefix = found.prefix;
        this.excel.numberStart = this.formatNumber(found.id_start);
        this.excel.numberEnd = this.formatNumber(found.id_end);
        if (found.last_imported && found.quantity_imported > 0) {
          this.isBackupChild = true;
        } else {
          this.isBackupChild = false;
        }
        this.selectedChild = true;
      }
    } else {
      this.isBackupChild = false;
      this.selectedChild = false;
      let batch = parseInt(this.excel.batch);
      var found = this.allBatchs.find(function (element) {
        if (element["id"] === batch) return element;
      });
      if (found) {
        this.excel.batch_id = this.excel.batch;
        this.excel.id_start = found.id_start;
        this.excel.id_end = found.id_end;
        this.excel.number = found.id_end - found.id_start + 1;
        this.excel.prefix = found.prefix;
        this.excel.numberStart = this.formatNumber(found.id_start);
        this.excel.numberEnd = this.formatNumber(found.id_end);
        if (found.last_imported && found.quantity_imported > 0) {
          this.isBackupBatch = true;
        } else {
          this.isBackupBatch = false;
        }
      }
    }

    this.fileExcel = null;
    this.numberStamp = null;
    this.numberSheet = null;
    $("#fileSelect").val("");
  }
  batchBackup() {
    if (this.excel.batch) {
      this.batchService.getBatchDetail(this.excel.batch).subscribe(res => {
        if (!res.error) {
          let dataBatch = res.data;
          this.backup_Batch(dataBatch);
        }
      });
    }
  }
  childBackup() {
    if (this.excel.batchChild) {
      this.batchService.getBatchDetail(this.excel.batchChild).subscribe(res => {
        if (!res.error) {
          let dataBatch = res.data;
          this.backup_Batch(dataBatch);
        }
      });
    }
  }
  backup_Batch(batch?: any) {
    let request: any = {};
    request.start = batch.id_start;
    request.end = batch.id_end;
    request.prefix_id = batch.prefix_id;
    request.fields = "&fields=serial,qrm,qri,sms";
    let query =
      "?start=" + request.start + "&end=" + request.end + request.fields;
    if (localStorage.getItem("Access-Token")) {
      query += "&Access_Token=" + localStorage.getItem("Access-Token");
    }
    let url =
      environment.api_evs + "/stamps/batch/" + batch.id + "/download" + query;
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.setAttribute("style", "display: none");
    a.href = url;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove(); // remove the element
    this.columns = {};
  }
  startFocusout() {
    if (this.excel.batch) {
      if (parseInt(this.excel.numberStart) < this.excel.id_start) {
        this.toastr.warning(this.translate.instant("KHONG_DUOC_NHO_HON_KHOANG_BAT_DAU_LO"), "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right"
        });
        this.excel.numberStart = this.formatNumber(this.excel.id_start);
        $("#start").val(this.excel.numberStart);
      }

      if (parseInt(this.excel.numberStart) > parseInt(this.excel.numberEnd)) {
        this.toastr.warning(
          this.translate.instant("KHOANG_BAT_DAU_KHONG_LON_HON_KHOANG_KET_THUC"),
          "",
          {
            timeOut: 4000,
            positionClass: "toast-bottom-right"
          }
        );
        this.excel.numberStart = this.excel.numberEnd;
        $("#start").val(this.excel.numberEnd);
      }
      this.excel.numberStart = this.formatNumber(
        parseInt(this.excel.numberStart)
      );
      this.excel.number =
        parseInt(this.excel.numberEnd) - parseInt(this.excel.numberStart) + 1;
    }
  }
  endFocusout() {
    if (this.excel.batch) {
      if (parseInt(this.excel.numberEnd) <= this.excel.id_start) {
        this.toastr.warning(
          this.translate.instant("KHONG_DUOC_NHO_HON_HOAC_BANG_KHOANG_BAT_DAU_LO"),
          "",
          {
            timeOut: 4000,
            positionClass: "toast-bottom-right"
          }
        );
        this.excel.numberEnd = this.formatNumber(this.excel.id_start);
        $("#end").val(this.excel.numberEnd);
      }
      if (parseInt(this.excel.numberEnd) < parseInt(this.excel.numberStart)) {
        this.toastr.warning(
          this.translate.instant("KHOANG_KET_THUC_KHONG_NHO_HON_KHOANG_BAT_DAU"),
          "",
          {
            timeOut: 4000,
            positionClass: "toast-bottom-right"
          }
        );
        this.excel.numberEnd = this.excel.numberStart;
        $("#end").val(this.excel.numberStart);
      }
    }
    this.excel.numberEnd = this.formatNumber(parseInt(this.excel.numberEnd));
    this.excel.number =
      parseInt(this.excel.numberEnd) - parseInt(this.excel.numberStart) + 1;
  }
  importStamp() {
    if (this.isExcel) {
      clickTracking("qcheck_batch_detail", "map_code_import", '', '')
      if (!this.isLoadingFile) {
        if (this.isSelectBatch && !this.excel.batch) {
          this.toastr.warning(this.translate.instant("BAN_PHAI_CHON_LO_TEM"), "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right"
          });
        }
        if (!this.fileExcel) {
          this.toastr.warning(this.translate.instant("BAN_PHAI_TAI_LEN_FILE_EXCEL_MA_NOI_BO"), "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right"
          });
        }
        if (this.isSelectBatch) {
          if (this.excel.batch_id && this.fileExcel) {
            this.isImport = true;
            let body = {
              batch_id: parseInt(this.excel.batch_id)
              //id_start: parseInt(this.excel.numberStart),
              //id_end: parseInt(this.excel.numberEnd)
            };
            if (this.isBackupBatch || this.isBackupChild) {
              this.confirmationService.confirm({
                message: this.translate.instant("TEM_LIEN_KET_BI_GHI_DE_TIEP_TUC"),
                header: this.translate.instant("CANH_BAO"),
                accept: () => {
                  this.batchService.ImportStamp(body, this.fileExcel).subscribe(
                    res_payload => {
                      this.isImport = false;
                      if (!res_payload.error) {
                        if (res_payload.data) {
                          this.toastr.info(
                            this.translate.instant("FILE_LIEN_KET_CHO_HANG_DOI"),
                            "",
                            {
                              enableHtml: true,
                              timeOut: 5000,
                              positionClass: "toast-bottom-right"
                            }
                          );
                        }
                      }
                    },
                    err => {
                      this.isImport = false;
                      this.toastr.error(err.message, "", {
                        enableHtml: true,
                        timeOut: 5000,
                        positionClass: "toast-bottom-right"
                      });
                    }
                  );
                },
                reject: () => {
                  this.isImport = false;
                }
              });
            } else {
              this.confirmationService.confirm({
                message: this.translate.instant("XAC_NHAN_LIEN_KET_LO_TEM"),
                header: this.translate.instant("THONG_BAO"),
                accept: () => {
                  this.batchService.ImportStamp(body, this.fileExcel).subscribe(
                    res_payload => {
                      this.isImport = false;
                      if (!res_payload.error) {
                        if (res_payload.data) {
                          this.toastr.info(
                            this.translate.instant("FILE_LIEN_KET_CHO_HANG_DOI"),
                            "",
                            {
                              enableHtml: true,
                              timeOut: 5000,
                              positionClass: "toast-bottom-right"
                            }
                          );
                        }
                      }
                    },
                    err => {
                      this.isImport = false;
                      this.toastr.error(err.message, "", {
                        enableHtml: true,
                        timeOut: 5000,
                        positionClass: "toast-bottom-right"
                      });
                    }
                  );
                },
                reject: () => {
                  this.isImport = false;
                }
              });
            }
          }
        } else {
          if (this.fileExcel) {
            this.isImport = true;
            let body = {};
            if (this.isBackupBatch || this.isBackupChild) {
              this.confirmationService.confirm({
                message: this.translate.instant("TEM_LIEN_KET_BI_GHI_DE_TIEP_TUC"),
                header: this.translate.instant("CANH_BAO"),
                accept: () => {
                  this.batchService.ImportStamp(body, this.fileExcel).subscribe(
                    res_payload => {
                      this.isImport = false;
                      if (!res_payload.error) {
                        if (res_payload.data) {
                          this.toastr.info(
                            this.translate.instant("FILE_LIEN_KET_CHO_HANG_DOI"),
                            "",
                            {
                              enableHtml: true,
                              timeOut: 5000,
                              positionClass: "toast-bottom-right"
                            }
                          );
                        }
                      }
                    },
                    err => {
                      this.isImport = false;
                      this.toastr.error(err.message, "", {
                        enableHtml: true,
                        timeOut: 5000,
                        positionClass: "toast-bottom-right"
                      });
                    }
                  );
                },
                reject: () => {
                  this.isImport = false;
                }
              });
            } else {
              this.confirmationService.confirm({
                message: this.translate.instant("XAC_NHAN_LIEN_KET_LO_TEM"),
                header: this.translate.instant("THONG_BAO"),
                accept: () => {
                  this.batchService.ImportStamp(body, this.fileExcel).subscribe(
                    res_payload => {
                      this.isImport = false;
                      if (!res_payload.error) {
                        if (res_payload.data) {
                          this.toastr.info(
                            this.translate.instant("FILE_LIEN_KET_CHO_HANG_DOI"),
                            "",
                            {
                              enableHtml: true,
                              timeOut: 5000,
                              positionClass: "toast-bottom-right"
                            }
                          );
                        }
                      }
                    },
                    err => {
                      this.isImport = false;
                      this.toastr.error(err.message, "", {
                        enableHtml: true,
                        timeOut: 5000,
                        positionClass: "toast-bottom-right"
                      });
                    }
                  );
                },
                reject: () => {
                  this.isImport = false;
                }
              });
            }
          }
        }
      }
    } else {
      clickTracking("qcheck_batch_detail", "map_code_serial", '', '')
      let listCustomerCode: any = [];
      let listIcheckSerial: any = [];
      let h = 0;
      for (let i = 0; i < this.listDataImport.length; i++) {
        let item: any = [];
        item.push($("#serial" + this.listDataImport[i]).val());
        item.push($("#qrm" + this.listDataImport[i]).val());
        item.push($("#qri" + this.listDataImport[i]).val());
        item.push($("#sms" + this.listDataImport[i]).val());
        if (
          $("#qrm" + this.listDataImport[i]).val() != "" &&
          $("#serialIcheck" + this.listDataImport[i]).val() != ""
        ) {
          listCustomerCode.push(item);
          listIcheckSerial.push(
            $("#serialIcheck" + this.listDataImport[i]).val()
          );
          $("#serialvali" + this.listDataImport[i]).text("");
          $("#qrmvali" + this.listDataImport[i]).text("");
        }
        if ($("#serialIcheck" + this.listDataImport[i]).val() != "") {
          $("#serialvali" + this.listDataImport[i]).text("");
        }
        if ($("#qrm" + this.listDataImport[i]).val() != "") {
          $("#qrmvali" + this.listDataImport[i]).text("");
        }

        if ($("#serialIcheck" + this.listDataImport[i]).val() == "") {
          $("#serialvali" + this.listDataImport[i]).text(this.translate.instant("KHONG_DUOC_DE_TRONG"));
          h++;
        }
        if ($("#qrm" + this.listDataImport[i]).val() == "") {
          $("#qrmvali" + this.listDataImport[i]).text(this.translate.instant("KHONG_DUOC_DE_TRONG"));
          h++;
        }
      }
      let body = {
        customer_code: listCustomerCode,
        icheck_serial: listIcheckSerial
      };
      if (h == 0)
        this.batchService.ImportStamp(body).subscribe(
          res => {
            this.isImport = false;
            if (!res.error && res.data) {
              this.toastr.info(
                this.translate.instant("THANH_CONG") + ": " +
                (res.data.success ? res.data.success : 0) +
                " tem <br />" + this.translate.instant("THAT_BAI") + ": " +
                res.data.fail +
                " tem ",
                "",
                {
                  enableHtml: true,
                  timeOut: 4000,
                  positionClass: "toast-bottom-right"
                }
              );

              if (res.data.payload_error.c_data.length) {
                if (
                  res.data.payload_error.c_data.length > 0 &&
                  res.data.payload_error.i_data.length > 0
                ) {
                  this.confirmationService.confirm({
                    message: this.translate.instant("GHI_DE_DONG_Y", { count: res.data.payload_error.c_data.length }),
                    header: this.translate.instant("THONG_BAO"),
                    accept: () => {
                      let data_payload = res.data.payload_error;
                      let bodyPayload = {
                        customer_code: data_payload.c_data,
                        icheck_serial: data_payload.i_data,
                        override: true
                      };
                      this.isImport = true;
                      this.batchService.ImportStamp(bodyPayload).subscribe(
                        res_payload => {
                          this.isImport = false;
                          if (!res_payload.error && res_payload.data) {
                            this.toastr.info(
                              this.translate.instant("SUCCESS_UPDATE") + ": " +
                              (res_payload.data.success
                                ? res_payload.data.success
                                : 0) +
                              " tem <br />" + this.translate.instant("THAT_BAI") + ": " +
                              res_payload.data.error.length +
                              " tem ",
                              "",
                              {
                                enableHtml: true,
                                timeOut: 4000,
                                positionClass: "toast-bottom-right"
                              }
                            );
                          }
                        },
                        err => {
                          this.isImport = false;
                          this.toastr.error(err.message, "", {
                            enableHtml: true,
                            timeOut: 5000,
                            positionClass: "toast-bottom-right"
                          });
                        }
                      );
                    },
                    reject: () => {
                      this.isImport = false;
                    }
                  });
                }
              }
            }
          },
          err => {
            this.isImport = false;
            this.toastr.error(err.message, "", {
              enableHtml: true,
              timeOut: 5000,
              positionClass: "toast-bottom-right"
            });
          }
        );
    }
  }
  timeout: any = null;

  changeCheckboxSigleValue() {

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.timeout = setTimeout(() => {

      let id = '';
      if ($('#checkboxSigleVal').val().search('http') !== -1) {
        const splitLink = $('#checkboxSigleVal').val().split('/')
        id = splitLink[splitLink.length - 1]
      } else {
        id = $('#checkboxSigleVal').val()
      }

      if (id) {
        console.log('id', id)

        this.batchService
          .detailStamp(id)
          .subscribe((val) => {
            if (val.code === 1) {
              this.addStamp(val.data)
            } else {
              this.toastr.warning(this.translate.instant("TEM_KHONG_HOP_LE"), this.translate.instant("CANH_BAO"), {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              });
            }
            console.log('val', val)
          })
      } else {
        this.toastr.warning(this.translate.instant("TEM_KHONG_HOP_LE"), this.translate.instant("CANH_BAO"), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
      $('#checkboxSigleVal').val('')

    }, 200);
  }
  addStamp(val) {
    this.numberID++;
    $("#itemInput").append(
      `
        <div id="info` +
      this.numberID +
      `" class="col-12" style="position: relative">
                    <div class="row">
                        <div class="col-2 w-p20">
                            <div class="form-group">
                                <input id="serial` +
      this.numberID +
      `" type="text" class="form-control form-control-sm" placeholder="` + this.translate.instant("SERIAL_NOI_BO_PLACEHOLDER") + `"/>
                            </div>
                        </div>
                        <div class="col-2 w-p20">
                            <div class="form-group">
                                <input id="qrm` +
      this.numberID +
      `" type="text" class="form-control form-control-sm" placeholder="` + this.translate.instant("QRM_NOI_BO_PLACEHOLDER") + `" />
                                <small id="qrmvali` +
      this.numberID +
      `" style="color: red"></small>
                            </div>
                        </div>
                        <div class="col-2 w-p20">
                            <div class="form-group">
                                <input id="qri` +
      this.numberID +
      `" type="text" class="form-control form-control-sm" placeholder="` + this.translate.instant("QRI_NOI_BO_PLACEHOLDER") + `" />
                            </div>
                        </div>
                        <div class="col-2 w-p20">
                            <div class="form-group">
                                <input id="sms` +
      this.numberID +
      `" type="text" class="form-control form-control-sm" placeholder="` + this.translate.instant("SMS_NOI_BO_PLACEHOLDER") + `" />
                            </div>
                        </div>
                        <div class="col-2 w-p20">
                            <div class="form-group">
                                <input id="serialIcheck` +
      this.numberID +
      `" type="text" class="form-control form-control-sm" placeholder="Serial Icheck" value="` +
      val +
      `"/>
                                <small id="serialvali` +
      this.numberID +
      `" style="color: red"></small>
                            </div>
                        </div>
                    </div>

                <i id="` +
      "close" +
      this.numberID +
      `" class="icon wb-close" style="position: absolute; top: 8px; right: -5px; cursor: pointer"></i>
                </div>
        `
    );
    this.listDataImport.push(this.numberID);
    $("#" + "close" + this.numberID.toString()).click(function (res) {
      var index = parseInt(res.currentTarget.id.toString().split("close")[1]);
      for (let i = 0; i < that.listDataImport.length; i++) {
        if (that.listDataImport[i] == index) {
          $("#" + "info" + index.toString()).remove();
          that.listDataImport.splice(i, 1);
          //that.numberID--;
        }
      }
    });
    $("#" + "serialIcheck" + this.numberID.toString()).focusout(function (res) {
      if ($("#" + "serialIcheck" + that.numberID.toString()).val() !== "") {
        $("#" + "serialvali" + that.numberID.toString()).text("");
      } else {
        $("#" + "serialvali" + that.numberID.toString()).text(
          this.translate.instant("KHONG_DUOC_DE_TRONG")
        );
      }
    });
  }
  formatSerial(id, prefix) {
    let serial_f: string = "";
    id = id.toString();
    if (id && prefix) {
      let pad = "000000";
      let serial = pad.substring(0, 6 - id.length) + id;
      serial_f = prefix + "-" + serial;
    }
    return serial_f;
  }
  formatNumber(id) {
    let numString: string = "";
    id = id.toString();
    if (id) {
      let pad = "000000";
      let serial = pad.substring(0, 6 - id.length) + id;
      numString = serial.toString();
    }
    return numString;
  }
  resetForm(filterForm) { }

  showDownloadBatch(templateDownload) {
    this.bsModalDownload = this.modalService.show(templateDownload);
  }
  downloadBatch() {
    if (Object.keys(this.columns).length <= 0) {
      this.toastr.warning(this.translate.instant("PHAI_CHON_IT_NHAT_MOT_COT"), this.translate.instant("THONG_BAO") + ":", {
        timeOut: 4000,
        positionClass: "toast-top-right"
      });
    } else {
      this.is_downloading_batch = true;
      let currentBatch = this.item_detail;
      let request: any = {};
      request.start = currentBatch.id_start;
      request.end = currentBatch.id_end;
      request.prefix_id = currentBatch.prefix_id; // dm, cai nay nhớ là prefix_id nhé, đéo phải batch_id như ở link download bên dưới đâu nhé. LOL.@chuongnv
      request.prefix = currentBatch.prefix;
      request.fields = "&fields=";
      if (this.columns.serial) request.fields += "serial";
      if (this.columns.qrm) {
        if (request.fields.length <= 0) request.fields += "qrm";
        else request.fields += ",qrm";
      }
      if (this.columns.qri) {
        if (request.fields.length <= 0) request.fields += "qri";
        else request.fields += ",qri";
      }
      if (this.columns.sms) {
        if (request.fields.length <= 0) request.fields += "sms";
        else request.fields += ",sms";
      }
      // let ext = 'xlsx';
      // let filename = '#'+this.item_detail.id+'_'+this.item_detail.name+'.'+ext;
      let query =
        "?start=" + request.start + "&end=" + request.end + request.fields;
      if (localStorage.getItem("Access-Token")) {
        query += "&Access_Token=" + localStorage.getItem("Access-Token");
      }
      let url =
        environment.api_evs +
        "/stamps/batch/" +
        currentBatch.id +
        "/download" +
        query;
      let a = document.createElement("a");
      document.body.appendChild(a);
      a.setAttribute("style", "display: none");
      a.href = url;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove(); // remove the element
      this.columns = {};
    }
  }
  showPopupLogsActiveBatchChild() {
    // this.isActiveBatch = false;
    const initialState = {
      batch_detail: this.item_detail
    };
    this.bsModalRef = this.modalService.show(ModalListBatchChildComponent, {
      initialState,
      class: "modal-list-batch-child"
    });
    this.bsModalRef.content.closeBtnName = this.translate.instant("QUAY_LAI");
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/batchstamp/import-stamp/import-stamp.component.ts